import type { FaireProductEntity } from "../../entity_types/product";

export const p_nur7maa4ng: FaireProductEntity = {
  token: "p_nur7maa4ng",
  type: "product",
  name: "Orange Petal Marshmallow | BEST SELLER | 8 oz Candle",
  brandToken: "b_ymy9myk6jv",
  brandName: "Kandlery",
  imageUrl:
    "https://cdn.faire.com/fastly/a77ad980e9b7b4a54bfa0fa82eafdd5b87364db7e49caeb2955345f1bc10d14c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87c7f10def16bdef1452d548dfa3d44c32ba62714c4bfa77c15c4d92653cefc4.jpeg",
    "https://cdn.faire.com/fastly/54d77a3f604bbc9569c689aaf7f6fa08f6efc71521d9a9d99820f7a3a803f3c7.png",
    "https://cdn.faire.com/fastly/07d801ec0e2dfa147d3e24a2a0fa0f22bb3c84bfd16defed3ad81ae4fd434703.png",
  ],
  priceDollars: 16,
  description:
    "Soft and sweet, this candle blends bright orange blossom and neroli with a touch of jasmine for a light floral start. Warm notes of caramelized sugar, and musk create a cozy, creamy finish.\n\nIt's the perfect scent for relaxing evenings or adding a gentle, inviting warmth to any room.\n\n𝐒𝐢𝐳𝐞 𝐨𝐩𝐭𝐢𝐨𝐧𝐬:\n• 8 oz. wood wicked iridescent glass jar with a lid\n\nNon-toxic | cruelty-free | pet-friendly\n\nProudly 'Made Better Certified'.\nOur goal is to source supplies with the highest quality standards in mind.\n\n𝐖𝐡𝐲 𝐊𝐚𝐧𝐝𝐥𝐞𝐫𝐲?\n• Natural Coconut Wax\n• Crackling Wooden Wick, Made from FSC Certified Wood.\n• Lead free & Self-trimming Cotton Wick\n• Non Toxic Ingredients\n• Premium Soothing Fragrances (Free of phthalate, reproductive toxins, and other concerning chemicals.)\n• Cruelty Free\n• Handcrafted in Small Batch\n• Untapped Asian-inspired scents",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:07.821Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
